import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useShallow } from 'zustand/react/shallow';
import { useLastLocation } from 'react-router-last-location';

// Import hooks
import { useSummaryStore } from 'components/views/offer_configurator/hooks/useSummaryStore';

// Import routes
import { MAIN_PATHS } from 'components/routes/app_routes/paths';
import { AuthPaths } from 'components/routes/auth/routes';

const { OFFER_CONFIGURATOR, PAYMENT_VERIFICATION } = MAIN_PATHS;

const ALLOWED_PATHS = [OFFER_CONFIGURATOR, PAYMENT_VERIFICATION, AuthPaths.Default];

export const useTemporaryProtection = () => {
	const history = useHistory();
	const action = useSummaryStore(useShallow((state) => state.action));
	const lastLocation = useLastLocation();

	useEffect(() => {
		if (lastLocation && !ALLOWED_PATHS.some((path) => lastLocation.pathname.startsWith(path))) {
			history.replace(OFFER_CONFIGURATOR);
		}
	}, []);

	useEffect(() => {
		if (!action) {
			history.replace(OFFER_CONFIGURATOR);
		}
	}, [action]);
};
